import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import ApiClient, { apiClient, ApiError } from "../utils/api";
import { QueryKey } from "@/utils/query-key";

type ApiQueryKey<ArgumentsType extends readonly unknown[] = []> = readonly [QueryKey, ...ArgumentsType]

type UseApiQueryOptions<OutputType, KeyArgumentsType extends readonly unknown[] = []> = UseQueryOptions<OutputType, ApiError, OutputType, ApiQueryKey<KeyArgumentsType>>

export type ApiQuery<OutputType, KeyArgumentsType extends readonly unknown[] = []> = Omit<UseApiQueryOptions<OutputType, KeyArgumentsType>, 'queryFn' | 'queryKey'> & {
    queryFn: (apiClient: ApiClient) => Promise<OutputType>
    queryKey: ApiQueryKey<KeyArgumentsType>
}

export type CustomQueryOptions<OutputType, KeyArgumentsType extends readonly unknown[] = []> = Partial<Omit<ApiQuery<OutputType, KeyArgumentsType>, 'queryFn' | 'queryKey'>>

export type ApiQueryBuilder<OutputType, InputType = void, KeyArgumentsType extends readonly unknown[] = []> = (input: InputType) => ApiQuery<OutputType, KeyArgumentsType>

export function useApiQuery<OutputType, KeyArgumentsType extends readonly unknown[] = []>(query: ApiQuery<OutputType, KeyArgumentsType>, customOptions?: CustomQueryOptions<OutputType, KeyArgumentsType>) {
    return useQuery({
        ...query,
        queryFn: () => query.queryFn(apiClient),
        ...customOptions,
    })
}